import {
  AlertDialogContent as ChakraAlertDialogContent,
  forwardRef,
} from '@chakra-ui/react';
import React from 'react';

import { ModalContentProps } from '../ModalContent/ModalContent';

export type AlertDialogContentProps = ModalContentProps;

export const AlertDialogContent = forwardRef<
  AlertDialogContentProps,
  'section'
>((props, ref) => {
  return <ChakraAlertDialogContent {...props} ref={ref} />;
});
